export default __webpack_public_path__ + "static/media/Saltire.01c38162.svg";